import React, { FC } from 'react';

import Styled from './styles';
import { Typography } from '../typography';
import RoundImg from '../avatar';

const Members: FC<any> = ({ users }) => {
	return (
		<Styled.Row>
			<div style={{ display: 'flex', flexDirection: 'row' }}>
				{[...users].splice(0, 5).map((user: any, i: number) => {
					const { avatar, firstName, lastName } = user;
					const fullName = `${firstName || ''} ${lastName || ''}`;
					return (
						<div key={i} style={{ marginLeft: i === 0 ? 0 : -22 }}>
							<RoundImg avatar={avatar} size={42} isBorder name={fullName} />
						</div>
					);
				})}
			</div>
			{users.length > 5 ? (
				<Styled.Image>
					<Typography
						text={'+' + String(users.length - 5)}
						type="bold"
						size="normal"
					/>
				</Styled.Image>
			) : null}
		</Styled.Row>
	);
};

export default Members;
